import type { SubscribeProps } from "../types";
import { useFormStoreAdapter } from "./useFormStoreAdapter";

export const Subscribe = <TSelected,>({ selector, children }: SubscribeProps<TSelected>) => {
    const selectedState = useFormStoreAdapter(selector);
    return children(selectedState);
};
